'use strict';

angular.module('domain.advancedSearch').controller('AdvancedSearchAccount', [
	'AppService',
	'$scope',
	'$stateParams',
	function (AppService, $scope, $stateParams) {
		var AdvancedSearchAccount = this;
		var AdvancedSearch = $scope.AdvancedSearch;

		var init = function () {
			AdvancedSearch.changeSearchType(AdvancedSearch.entity.ACCOUNT, $stateParams.notificationEntityId);

			AdvancedSearch.loaded = true;
		};

		AppService.loadedPromise.then(init);
	}
]);
